import { render, staticRenderFns } from "./cromatografia.vue?vue&type=template&id=5b818e0b&lang=html&"
import script from "./cromatografia.vue?vue&type=script&lang=js&"
export * from "./cromatografia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports